import { render } from "./ClientList.vue?vue&type=template&id=757bc997&scoped=true"
import script from "./ClientList.vue?vue&type=script&lang=js"
export * from "./ClientList.vue?vue&type=script&lang=js"

import "./ClientList.vue?vue&type=style&index=0&id=757bc997&scoped=true&lang=css"

import exportComponent from "/home/umut/Desktop/tm-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-757bc997"]])

export default __exports__